import { render, staticRenderFns } from "./ItemVideo.vue?vue&type=template&id=380394ec&"
import script from "./ItemVideo.vue?vue&type=script&lang=js&"
export * from "./ItemVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports